export default {
    currentVersion: null,
    checkUrl: null,
    checkInterval: null,
    reloadPending: false,

    init() {
        const meta = $("meta[name='app-asset-version']");
        if (!meta.length) {
            return;
        }

        this.currentVersion = meta.attr("content");
        this.checkUrl = meta.attr("data-check-url");

        $(window).on("focus", () => this.check());
        $(document).on("visibilitychange", () => {
            if (!document.hidden) {
                this.check();
            }
        });
        $(document).on("hidden.bs.modal", () => this.reloadIfPossible());

        this.checkInterval = window.setInterval(() => this.check(), 60000);
    },

    check() {
        if (!this.checkUrl || document.hidden) {
            return;
        }

        $.ajax({
            url: this.checkUrl,
            method: "GET",
            cache: false,
            dataType: "json",
        }).done((response) => {
            if (response.version && response.version !== this.currentVersion) {
                this.reloadPending = true;
                this.reloadIfPossible();
            }
        });
    },

    reloadIfPossible() {
        if (!this.reloadPending || $(".modal.show").length || $("form[aria-busy='true']").length) {
            return;
        }

        window.location.reload();
    },
};
